/**
 * Smatchy
 * The smatchy API description. Use POST /auth/login to get an access token.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PayoutEventDto { 
    /**
     * Event ID
     */
    eventId: string;
    /**
     * Event title
     */
    eventTitle: string;
    /**
     * Sport name
     */
    sportName?: string;
    /**
     * Event start date
     */
    startDate?: string;
    /**
     * Event end date
     */
    endDate?: string;
    /**
     * Event location name
     */
    location?: string;
    /**
     * Event status
     */
    eventStatus?: PayoutEventDto.EventStatusEnum;
    /**
     * Ticket price in cents
     */
    costPerParticipant?: number;
    /**
     * Number of tickets sold
     */
    ticketsSold: number;
    /**
     * Number of refunded tickets
     */
    refundedTickets: number;
    /**
     * Total ticket revenue in cents
     */
    totalTicketPaid: number;
    /**
     * Total refunded amount in cents
     */
    totalRefundedAmount: number;
    /**
     * Total Stripe fees in cents
     */
    totalStripeFee: number;
    /**
     * Platform commission percentage
     */
    commissionPercentage: number;
    /**
     * Platform commission amount in cents
     */
    platformEarning: number;
    /**
     * Organizer net earning in cents
     */
    organizerEarning: number;
    /**
     * Payout status for this event
     */
    payoutStatus: string;
    /**
     * When funds entered escrow
     */
    inEscrowAt?: string;
    /**
     * When funds became available
     */
    availableAt?: string;
    /**
     * sport type id
     */
    sportTypeId?: string;
    /**
     * Event finance stats ID (reference to EventFinanceStats)
     */
    eventFinanceStatsId?: string;
}
export namespace PayoutEventDto {
    export type EventStatusEnum = 'scheduled' | 'in_progress' | 'finished';
    export const EventStatusEnum = {
        Scheduled: 'scheduled' as EventStatusEnum,
        InProgress: 'in_progress' as EventStatusEnum,
        Finished: 'finished' as EventStatusEnum
    };
}


